import Generic from 'assets/svg/card-brands/generic-card.svg';
import Visa from 'assets/svg/card-brands/visa.svg';
import Mastercard from 'assets/svg/card-brands/mastercard.svg';
import AmericanExpress from 'assets/svg/card-brands/american-express.svg';
import Discover from 'assets/svg/card-brands/discover.svg';
import JCB from 'assets/svg/card-brands/jcb.svg';
import UnionPay from 'assets/svg/card-brands/union-pay.svg';
import Diners from 'assets/svg/card-brands/diners-club.svg';

import { useFormContext } from 'react-hook-form';
import { SignUpStep3Schema } from 'blocks/sign-up/schemas';

import creditCardType from 'credit-card-type';

import { BrandIconProps } from './types';

import styles from './BrandIcon.module.scss';

const BrandIcon: React.FC<BrandIconProps> = props => {
  const { watch } = useFormContext<SignUpStep3Schema>();
  const cardNumber = watch('creditCard.number');

  const matchedBrands = creditCardType(cardNumber);

  let brand = {
    type: 'default',
  };

  if (cardNumber.length > 1 && matchedBrands.length > 0) {
    brand = matchedBrands[0];
  }

  const Icon = brandToIcon[brand.type] || brandToIcon.default;

  return <Icon className={styles.container} {...props} />;
};

export default BrandIcon;

const brandToIcon = {
  visa: Visa,
  mastercard: Mastercard,
  'american-express': AmericanExpress,
  discover: Discover,
  jcb: JCB,
  unionpay: UnionPay,
  'diners-club': Diners,
  default: Generic,
} as Record<string, React.FC<BrandIconProps>>;
